import { createSelector } from "@ngrx/store";
import { AppStateInterface } from "../../appState.interface";

export const selectFeature = (state: AppStateInterface) => state.deviceLocations;

export const isLoadingSelector = createSelector(
    selectFeature, 
    (state) => state.isLoading
);

export const deviceLocationSelector = createSelector(
    selectFeature, 
    (state) => state.deviceLocations
);

export const errorSelector = createSelector(
    selectFeature, 
    (state) => state.error
);